import { render } from "./ExportPrivKey.vue?vue&type=template&id=7f3e205c"
import script from "./ExportPrivKey.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportPrivKey.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/ExportPrivKey.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f3e205c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f3e205c', __exports__)) {
    api.reload('7f3e205c', __exports__)
  }
  
  module.hot.accept("./ExportPrivKey.vue?vue&type=template&id=7f3e205c", () => {
    api.rerender('7f3e205c', render)
  })

}


export default __exports__